export default __webpack_public_path__ + "static/media/Prom_3_2.cecf9c59.png";